import React, { useEffect, useState } from 'react'
import MySelect from '../../../../UI/form/MySelect'

const WriteOffActStatusSelect = ({ required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState(
		forciblyValue && forciblyValue === true ? 'yes' :
		forciblyValue === false ? 'no' : forciblyValue
	)
  	const [validSelect, setValidSelect] = useState(false)
	const [options, setOptions] = useState([
		{
			id: 'new',
			name: 'Нова'
		},
		{
			id: 'work',
			name: 'В роботі'
		},
		{
			id: 'approval',
			name: 'На погодженні'
		},
		{
			id: 'approved',
			name: 'Погоджено'
		},
		{
			id: 'success',
			name: 'Успішна'
		},
		{
			id: 'cancel',
			name: 'Скасована'
		},
	])

	useEffect(() => {
		valid()
	}, [required, value])

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
				setValidSelect(true)
			} else {
				setValidate(false)
				setValidSelect(false)
			}
		} else {
			setValidate(true)
			setValidSelect(true)
		}
	}

  return (
    <MySelect
        value={value}
        label="Статус"
        labelId="select__status-label"
        id='select__status'
        onChange = {e => {
			setValueForm(e)
            setValue(e)
			// setEvent({...event, categoryId: e})
		}}
        nameField='Статус'
        // sx={{width: '200px'}}
        options={
			options && options.length > 0 ? 
				options.map(option => {
            		return {id: option.id, name: option.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default WriteOffActStatusSelect